export default [
    {
    	start: 6850,
    	previous: 0,
        scrollDistance: 9000
    },
    {
    	start: 13000,
    	previous: 9000,
        scrollDistance: 14500
    },
    {
    	start: 18100,
    	previous: 14500,
        scrollDistance: 20000
    },
    {
    	start: 25000,
    	previous: 20000,
      	scrollDistance: 25800
    },
    {
    	start: 25800,
    	previous: 25000,
        scrollDistance: 31200
    },
];
